import React from 'react'
import PropTypes from 'prop-types'
import sScrollList from './ScrollList.less'
import sScrollListTitle from './ScrollListWithTitle.less'
import ScrollListWithTitlePlaceholder from './ScrollListWithTitlePlaceholder'
import ResponsiveScrollList from './ResponsiveScrollList'

const ScrollListWithTitle = ({ title, data, ...restProps }) => (
  <div className={sScrollListTitle.container}>
    {data ? (
      <>
        <div className={sScrollListTitle.title}>{title}</div>
        <ResponsiveScrollList
          {...{ data, ...restProps }}
          listClassName={sScrollList.list}
          listItemClassName={sScrollList.listItem}
          arrowClassName={sScrollList.arrow}
          arrowLeftClassName={sScrollList.arrowLeft}
          arrowRightClassName={sScrollList.arrowRight}
        />
      </>
    ) : (
      <ScrollListWithTitlePlaceholder />
    )}
  </div>
)

ScrollListWithTitle.propTypes = {
  title: PropTypes.node,
  ...ResponsiveScrollList.propTypes,
  data: PropTypes.array
}

export default ScrollListWithTitle
